(() => {
  'use strict';
  const titles = {signature:'A little golden possibility.',treefarm:'Make room for a little Christmas.',santapaws:'For someone on the nice list.',fireside:'Something for a golden night in.'};
  const designNames = {signature:'Signature',treefarm:'Tree Farm',santapaws:'Santa Paws',fireside:'Fireside Goldens'};
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function flipCard(card,flipped){
    card.classList.toggle('is-flipped',flipped);
    card.querySelector('.lgc-card__front').setAttribute('aria-hidden',String(flipped));
    card.querySelector('.lgc-card__back').setAttribute('aria-hidden',String(!flipped));
  }
  function celebrate(host) {
    if (!host || reduced()) return;
    host.replaceChildren();
    for (let i=0;i<58;i++) {
      const p=document.createElement('i');
      p.style.setProperty('--piece-color',['#b88c47','#284c3d','#e6d2a4','#9e5146'][i%4]);
      p.style.setProperty('--x',`${(Math.random()-.5)*Math.min(innerWidth,900)}px`);
      p.style.setProperty('--y',`${120+Math.random()*500}px`);
      p.style.setProperty('--spin',`${Math.random()*900-450}deg`);
      p.style.setProperty('--delay',`${Math.random()*.12}s`);
      host.append(p);
    }
    setTimeout(()=>host.replaceChildren(),1800);
  }
  function openEnvelope(root) {
    const button=root.querySelector('[data-open-envelope]');
    const envelope=root.querySelector('[data-envelope]');
    const card=root.querySelector('[data-revealed-card]');
    if (!button || !card || button.disabled) return;
    button.disabled=true;
    envelope?.classList.add('is-open');
    setTimeout(()=>{
      if(envelope) envelope.hidden=true;
      button.hidden=true;
      card.hidden=false;
      celebrate(root.querySelector('[data-confetti]'));
      root.querySelector('[data-card-flip]')?.focus({preventScroll:true});
    },reduced()?0:550);
  }
  function initStudio(root) {
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    const form=root.querySelector('form');if(!form) return;
    const select=root.querySelector('[data-gift-variant]');
    const variants=JSON.parse(root.querySelector('[data-gift-variants]').textContent);
    const price=v=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:root.dataset.currency||'USD',maximumFractionDigits:2,minimumFractionDigits:v.price%100?2:0}).format(v.price/100);
    const variantByAmount=a=>variants.find(v=>Number(String(v.options?.[0]||v.title).replace(/[^\d.]/g,''))===Number(a));
    const selected=()=>variants.find(v=>String(v.id)===select.value);
    const recipient=root.querySelector('[data-recipient-name]'),sender=root.querySelector('[data-sender-name]'),message=root.querySelector('[data-gift-message]');
    const error=root.querySelector('[data-gift-error]');
    const submit=root.querySelector('[data-gift-submit]');
    root.classList.add('is-enhanced');
    // Keep the native select as the source of truth; sort its available denominations.
    [...select.options].sort((a,b)=>Number(a.dataset.cents)-Number(b.dataset.cents)).forEach(o=>select.append(o));
    root.querySelectorAll('[data-amount]').forEach(button=>{
      const v=variantByAmount(button.dataset.amount);
      button.disabled=!v?.available;
      if(v) button.textContent=price(v);
      button.addEventListener('click',()=>{select.value=String(v.id);root.querySelector('[data-amount-select-label]').classList.remove('is-visible');root.querySelector('[data-custom-help]').hidden=true;update();});
    });
    root.querySelector('[data-other-amount]').addEventListener('click',()=>{
      root.querySelector('[data-amount-select-label]').classList.add('is-visible');root.querySelector('[data-custom-help]').hidden=false;select.focus();
      root.querySelectorAll('[data-amount]').forEach(b=>b.setAttribute('aria-pressed','false'));
      root.querySelector('[data-other-amount]').setAttribute('aria-pressed','true');
    });
    const date=root.querySelector('[data-send-date]');
    root.querySelector('[data-recipient-email]').addEventListener('input',e=>e.currentTarget.setCustomValidity(''));
    date.addEventListener('input',e=>e.currentTarget.setCustomValidity(''));
    const dateString=d=>`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    const today=new Date(),last=new Date();last.setDate(last.getDate()+90);date.min=dateString(today);date.max=dateString(last);
    function updateDelivery() {
      const toRecipient=root.querySelector('[name="gift-delivery"]:checked').value==='recipient';
      const scheduled=toRecipient&&root.querySelector('[name="gift-timing"]:checked').value==='scheduled';
      root.querySelector('[data-recipient-fields]').hidden=!toRecipient;
      const email=root.querySelector('[data-recipient-email]');email.disabled=!toRecipient;email.required=toRecipient;
      root.querySelector('[data-recipient-flag]').disabled=!toRecipient;
      const offset=root.querySelector('[data-timezone]');offset.disabled=!toRecipient;offset.value=String(new Date().getTimezoneOffset());
      date.disabled=!scheduled;date.required=scheduled;root.querySelector('[data-date-label]').hidden=!scheduled;
      const summary=root.querySelector('[data-delivery-summary]');
      summary.textContent=!toRecipient?'We’ll email the gift card to the address you use at checkout after payment is complete.':scheduled?'We’ll email their gift card on your chosen date, after payment is complete.':'We’ll email their gift card after payment is complete. Delivery can take a few minutes.';
    }
    function update() {
      const v=selected();if(!v) return;
      const design=root.querySelector('[name="gift-design"]:checked').value;
      const back=root.querySelector('[data-back-input]').value;
      root.querySelector('[data-design-input]').value=design;
      root.querySelectorAll('[data-gift-card]').forEach(c=>{
        c.dataset.design=design;c.dataset.back=back;
        c.querySelector('[data-card-headline]').textContent=titles[design];
        c.querySelector('[data-card-amount]').textContent=price(v);
        c.querySelector('[data-card-to]').textContent=recipient.value.trim()?`For ${recipient.value.trim()}`:'For someone special';
        c.querySelector('[data-card-from]').textContent=sender.value.trim()?`With love, ${sender.value.trim()}`:'With love';
        c.querySelector('[data-card-message]').textContent=message.value||'A little something for whatever makes your tail wag.';
      });
      root.querySelectorAll('[data-summary-amount],[data-buy-amount]').forEach(x=>x.textContent=price(v));
      root.querySelector('[data-message-count]').textContent=String(message.value.length);
      root.querySelectorAll('[data-amount]').forEach(b=>b.setAttribute('aria-pressed',String(variantByAmount(b.dataset.amount)?.id===v.id)));
      const isPreset=[...root.querySelectorAll('[data-amount]')].some(b=>b.getAttribute('aria-pressed')==='true');
      root.querySelector('[data-other-amount]').setAttribute('aria-pressed',String(!isPreset));
      if(!isPreset){root.querySelector('[data-amount-select-label]').classList.add('is-visible');root.querySelector('[data-custom-help]').hidden=false;}
      submit.disabled=!v.available;
    }
    function showMainFace(flipped){
      const card=root.querySelector('[data-gift-card]');
      flipCard(card,flipped);
      const button=root.querySelector('[data-main-flip]');
      button.setAttribute('aria-pressed',String(flipped));
      button.innerHTML=`${flipped?'Show card front':'Show card back'} <span aria-hidden="true">↻</span>`;
    }
    root.querySelectorAll('[name="gift-design"]').forEach(radio=>radio.addEventListener('change',()=>{
      showMainFace(false);
      const stage=root.querySelector('.lgc-preview-stage');
      if(innerWidth<=850&&stage.getBoundingClientRect().top<80)stage.scrollIntoView({behavior:reduced()?'auto':'smooth',block:'start'});
    }));
    root.querySelectorAll('[data-back-choice]').forEach(b=>b.addEventListener('click',()=>{
      root.querySelector('[data-back-input]').value=b.dataset.backChoice;
      root.querySelectorAll('[data-back-choice]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));
      showMainFace(true);update();
      const stage=root.querySelector('.lgc-preview-stage');
      if(innerWidth<=850&&stage.getBoundingClientRect().top<80)stage.scrollIntoView({behavior:reduced()?'auto':'smooth',block:'start'});
    }));
    root.querySelectorAll('[data-card-flip]').forEach(b=>b.addEventListener('click',()=>{
      const card=(b.closest('dialog')||root).querySelector('[data-gift-card]');const flipped=!card.classList.contains('is-flipped');
      if(b.hasAttribute('data-main-flip'))showMainFace(flipped);else {flipCard(card,flipped);b.setAttribute('aria-pressed',String(flipped));}
    }));
    root.addEventListener('input',update);
    root.addEventListener('change',()=>{updateDelivery();update();});
    const dialog=root.querySelector('[data-reveal-dialog]');
    root.querySelector('[data-preview-reveal]').addEventListener('click',()=>{
      const env=dialog.querySelector('[data-envelope]');env.hidden=false;env.classList.remove('is-open');
      const button=dialog.querySelector('[data-open-envelope]');button.hidden=false;button.disabled=false;
      dialog.querySelector('[data-revealed-card]').hidden=true;flipCard(dialog.querySelector('[data-gift-card]'),false);dialog.querySelector('[data-card-flip]').setAttribute('aria-pressed','false');update();dialog.showModal();
    });
    dialog.querySelector('[data-dialog-close]').addEventListener('click',()=>dialog.close());
    dialog.querySelector('[data-open-envelope]').addEventListener('click',()=>openEnvelope(dialog));
    dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
    form.addEventListener('submit',async e=>{
      e.preventDefault();error.hidden=true;updateDelivery();
      if(!form.reportValidity())return;
      const v=selected();if(!v||!v.available||v.price<=0){error.textContent='Please choose an available gift card amount.';error.hidden=false;return;}
      submit.disabled=true;submit.setAttribute('aria-busy','true');
      const data=new FormData(form);data.set('id',String(v.id));data.set('quantity','1');data.set('properties[Card design]',designNames[root.querySelector('[data-design-input]').value]);data.set('properties[Card back]',{ivory:'Warm ivory',forest:'Forest green',red:'Holiday red'}[root.querySelector('[data-back-input]').value]);
      try{
        const response=await fetch(root.dataset.addUrl,{method:'POST',headers:{Accept:'application/json'},body:data});
        const result=await response.json();if(!response.ok){
          const errors=result.errors||result.description;
          if(errors&&typeof errors==='object'){
            const emailErrors=errors.email;
            if(emailErrors){const field=root.querySelector('[data-recipient-email]');field.setCustomValidity('Please enter a valid recipient email address.');field.reportValidity();}
            const detail=Object.values(errors).flat().filter(x=>typeof x==='string').join(' ');
            throw new Error(detail||'Please check your gift card details and try again.');
          }
          throw new Error(typeof result.description==='string'?result.description:'Your gift card could not be added. Please check your details and try again.');
        }
        root.querySelector('[data-gift-added]').hidden=false;root.querySelector('[data-gift-added]').scrollIntoView({behavior:reduced()?'auto':'smooth',block:'nearest'});
        // Use Horizon's cart contract so the bag count and drawer refresh together.
        // A refresh failure must never imply the successful addition failed.
        try {
          const cartResponse=await fetch(`${root.dataset.cartUrl}.js`,{headers:{Accept:'application/json'}});
          if(cartResponse.ok){
            const cart=await cartResponse.json();
            const {CartUpdateEvent}=await import(root.dataset.eventsUrl);
            document.dispatchEvent(new CartUpdateEvent(cart,form.id,{source:'lig-gift-card-studio',itemCount:cart.item_count}));
          }
        }catch{/* Checkout and Review your bag remain available. */}
      }catch(e){error.textContent=e.message||'Something went wrong. Please try again.';error.hidden=false;}
      finally{submit.disabled=false;submit.removeAttribute('aria-busy');}
    });
    updateDelivery();update();
  }
  function initIssued(root){
    if(root.dataset.ready)return;root.dataset.ready='true';
    root.querySelector('[data-open-envelope]')?.addEventListener('click',()=>openEnvelope(root));
    root.querySelector('[data-card-flip]')?.addEventListener('click',e=>{const card=root.querySelector('[data-gift-card]');const flipped=!card.classList.contains('is-flipped');flipCard(card,flipped);e.currentTarget.setAttribute('aria-pressed',String(flipped));});
    root.querySelectorAll('[data-gift-copy]').forEach(b=>b.addEventListener('click',async()=>{
      const field=root.querySelector('[data-gift-code]');const feedback=root.querySelector('[data-copy-feedback]');
      try{await navigator.clipboard.writeText(field.value.replace(/\s/g,''));feedback.textContent='Code copied. Paste it in the gift card field at checkout.';}catch{field.focus();field.select();feedback.textContent='Select and copy your code, then paste it in the gift card field at checkout.';}
    }));
    root.querySelector('[data-gift-print]')?.addEventListener('click',()=>window.print());
  }
  function init(){document.querySelectorAll('[data-gift-studio]').forEach(initStudio);document.querySelectorAll('[data-gift-issued]').forEach(initIssued);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
